import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container,TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col,Label, Input,Button, CardTitle, Badge, ModalFooter } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import {  Modal,ModalBody, ModalHeader} from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { AddZone, disableZone, enableZone, GetlisteZones, updateZone, UploadFileZone } from '../../services/ZonesServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile } from "../../services/ProfileServices/Api";
import Dropzone from "react-dropzone";
import { Form } from "react-router-dom";
import config from '../../config'
import { AddPage, disablePage, enablepage, GetlistePages, updatePage, UploadFilePage } from "../../services/PageServices/Api";
import { AddPageReservation, disablePageReservation, enablepageReservation, GetlistePagesReservation, updatePageReservation, UploadFilePageReservation } from "../../services/PageReservation/Api";
import { GetlisteReservation } from "../../services/ReservationServices/api";

const Reservation = () => {
  const [modalUpdateIsOpen,setmodalUpdateIsOpen] = useState(false)
  const [ListZones,setListZones] = useState([])
  const [User,setUser] = useState()
  const [dropdownValues, setDropdownValues] = useState({});
  const  [openmodal, setopenModal] = useState(false)
  const [activeTabJustify,setactiveTabJustify] = useState("1")
  const [memberSelected , setmemberSelected] = useState()
  const [selectedCity , setselectedCity]  = useState("")
  const [Nom , setNom]  = useState("")
  const [Prenom , setPrenom]  = useState("")
  const [RS , setRS]  = useState("")
  const [ZoneOpened , setZoneOpened] = useState({})
  const [tel , settel]  = useState("")
  const [ShowConfirmModal, setShowConfirmModal] = useState(false)
  const [ShowConfirmModalII, setShowConfirmModalII] = useState(false)
  const [ZoneSelected , setZoneSelected]  = useState("")
  const  [openedZone, setopenedZone] = useState()

  const [DesPage_Fr , setPage_Fr]  = useState("")
  const [DesPage_Ar , setPage_Ar]  = useState("")
  const [DesPage_Eng , setPage_Eng]  = useState("")

  const [adr_ferm , setadr_ferm]  = useState("")
  const [Email, setEmail] = useState()
  const [DaysSelected, setDaysSelected] = useState([])
  const [openmodalevaluate, setopenmodalevaluate] = useState(false)
  const [evaluatYear, setevaluatYear] = useState('')
  const [evaluatCmnt, setevaluatCmnt] = useState('')
  const [TypeRes, setTypeRes] = useState('')

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [ShowZones,setShowZones] = useState()
  const [dateRes,setdateRes] = useState()
  const [message,setmessage] = useState()
  const [Duration,setDuration] = useState()
  const [Tarif,setTarif] = useState()
  const [NbrPers,setNbrPers] = useState()





 



  

  const handleClickMember = (member) =>{
     setZoneOpened(member) 
    
     setNom(member['nom'])
     setPrenom(member['prenom'])
     setRS(member['rs'])
     setShowZones(member["showzones"])
     setEmail(member["email"])
     setdateRes(member["dateReservation"])
     setTypeRes((member["pageReservation"].title_fr))
     setDuration(member["pageReservation"].duree || "")
     setTarif(member["pageReservation"].tarif || "")
     setNbrPers(member["pageReservation"].nbrpers || "")

     setmessage(member["message"])

     setopenModal(true)
  }



  const  toggleCustomJustified = (tab) => {
		setactiveTabJustify(tab)
	}

  const  handleSelectCity = async (selectedGroup) => {
    console.log(selectedGroup)
    setselectedCity(selectedGroup);
  };


  const optionBlock = [
	{
		options: [
			{ label: "Explorez le Zoo", value: "Explorez le Zoo" },
			{ label: "Expériences", value: "Expériences" },
			{ label: "Préparez votre visite", value: "Préparez votre visite" },
			{ label: "Plan du Zoo", value: "Plan du Zoo" },

		]
	},
];



  const columns = useMemo(
    () => [
      {
        Header: "Type",
        accessor: "pageReservation",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Nom",
        accessor: "nom",
        disableFilters: true,
        filterable: false,
      },
      
      {
        Header: "Telephone",
        accessor: "tel",
        disableFilters: true,
        filterable: false,
      },
    ],
  );



  const GetData = async () =>{
    await GetlisteReservation().then(res =>{
      console.log(res)
      const filteredZones = res.filter(zone => zone.disable == false);

      //  for (let index = 0; index < res.length; index++) {
      //   res[index].nbr_ani = res[index].animaux.length
      //  }

      setListZones(res)
    
    }).catch(err =>{
      console.log(err)
    })
  }

    useEffect(() =>{
      const Data = JSON.parse(localStorage.getItem("authUser"))
      setUser(Data)

      GetData()
    },[])

    const initForm = () =>{
      setSelectedFiles([])
      setPrenom("")
      setNom("")
      setRS("")
      setPage_Ar("")
      setPage_Eng("")
      setPage_Fr("")
      setZoneOpened({})
    //   setShowZones(false)
    }

    const handleAcceptedFiles = (files) => {
      const updatedFiles = files.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          htmlFormattedSize: htmlFormatBytes(file.size),
        })
      );
      setSelectedFiles(updatedFiles);
    };

    const htmlFormatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

    const handleRemoveFile = (index) => {
      setSelectedFiles(prevFiles => {
          const updatedFiles = [...prevFiles];
          updatedFiles.splice(index, 1);
          return updatedFiles;
      });
  };


  const handleupdateZone = async () =>{
    if(selectedFiles.length !== 0 ){
      
    const formData = new FormData();
    formData.append('file', selectedFiles[0]);
      await UploadFilePageReservation(formData).then(async res =>{
        console.log(res)
      ZoneOpened['title_fr'] = Nom
      ZoneOpened['description_fr'] = DesPage_Fr
      ZoneOpened['title_ar'] = Prenom
      ZoneOpened['description_ar'] = DesPage_Ar
      ZoneOpened['title_en'] = RS
      ZoneOpened['description_en'] = DesPage_Eng
      ZoneOpened['img'] = res
      ZoneOpened['updatedAt'] = new Date()
      ZoneOpened['duree'] = Duration
      ZoneOpened['message'] = message
      ZoneOpened['dateRes'] = dateRes



    //   ZoneOpened['block'] = TypeRes.value


      await updatePageReservation(ZoneOpened).then(res =>{
        console.log(res.status)
        if (res.status === 200) {
  
          toastr.success('la zone ' + Nom + " était bien modifié" )
          setopenModal(false)
          initForm()
  
        } else {
          toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
  
        }
      })
    })
  } else {
    // ZoneOpened['block'] = TypeRes.value
    ZoneOpened['title_fr'] = Nom
    ZoneOpened['description_fr'] = DesPage_Fr
    ZoneOpened['title_ar'] = Prenom
    ZoneOpened['description_ar'] = DesPage_Ar
    ZoneOpened['title_en'] = RS
    ZoneOpened['description_en'] = DesPage_Eng
    ZoneOpened['updatedAt'] = new Date()
    ZoneOpened['duree'] = Duration
    ZoneOpened['message'] = message
    ZoneOpened['dateRes'] = dateRes



    await updatePageReservation(ZoneOpened).then(res =>{
      console.log(res.status)
      if (res.status === 200) {

        toastr.success('la zone ' + Nom + " était bien modifié" )
        setopenModal(false)
        initForm()

      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

  }
}


 
  const addZone = async () =>{

    console.log(selectedFiles[0])
    console.log(typeof(selectedFiles[0]))

    const formData = new FormData();
    formData.append('file', selectedFiles[0]);

    await UploadFilePageReservation(formData).then(async res =>{
      console.log(res)

    const DataPost = {
      "description_fr": DesPage_Fr,
      "title_fr": Nom,
      "description_ar": DesPage_Ar,
      "title_ar": Prenom,
      "description_en" : DesPage_Eng,
      "title_en" : RS,
      "img" : res,
      "ref" : Nom,
      "duree" : Duration,
      "message" : message,
      "dateRes" : dateRes
    
    }
    await AddPageReservation(DataPost).then(res =>{
      console.log(res.status)
      if (res.status === 201) {

        toastr.success('la zone ' + Nom + " était bien ajouté" )
        setopenModal(false)
        initForm()
        GetData()


      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

    })

    // const blobData = await fetch(URL.createObjectURL(selectedFiles[0])).then((res) => res.blob());
    // const blob = new Blob([blobData], { type: selectedFiles[0].type });
    // formData.append('files', blob, selectedFiles[0].name);


  }

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const handleAddnewZone = () => {
    setZoneOpened({})
    initForm()
    setopenModal(true)
  }

  const handleClickRemove = async () => {

    await disablePageReservation(openedZone).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmModal(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickEnable = async (Zone) =>{

    await enablepageReservation(openedZone).then((res) =>{
      console.log(res)
      if (res.status === 200) {
        toastr.success("la zone était bien activé" )
        GetData()
        setShowConfirmModalII(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
     })

  }


  // const updateZone = async () =>{
  //   console.log(memberSelected.profile)
  //   const Data = JSON.parse(localStorage.getItem("authUser"))
  //   memberSelected.profile['adrs_res'] = DesZone
  //   memberSelected.profile['Tel'] = tel
  //   memberSelected.profile['adrs_ferme'] = adr_ferm
  //   memberSelected.profile['City'] = selectedCity?.value
  //   memberSelected.profile['days_dispo'] = JSON.stringify(DaysSelected)

  //   const DataProfile = { Data : memberSelected.profile }
    
  //   await UpdateMemeberProfile(Data.token, DataProfile ).then(res =>{
  //     setopenModal(false)
  //     if(res['status'] == "success"){
  //       toastr.success('le profil de ' + NameZone + " était bien misé à jour" )
  //     }
  //   }).catch(err =>{
  //     toastr.error("Erreur lors de mises à jour le profile ")
  //   })
  // }



  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Demande de réservation"
            breadcrumbItems={[]}
          />
        
          <Card>
          {/* <div className="d-flex justify-content-end m-2 mt-2">
                <Button color="success" onClick={handleAddnewZone}>
                    Ajouter une page
                </Button>
          </div> */}
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={ListZones || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                // openModalUpdate={openModal}
                // isAddOptions={true}
                ShowPaggination={false}
                handleClickRow={handleClickMember}
                handleClickRemove={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModal(true)
                }}
                handleClickEnable={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModalII(true)

                }}
                dropdownData = {dropdownValues}
                userData={User}
              />
            </CardBody>
          </Card>
          <Modal
    size="xl"
    isOpen={openmodal}
    toggle={() => { setopenModal(false) }}
>
    <ModalHeader className="d-flex justify-content-between align-items-start" style={{ position: 'relative' }}>
        <span>Information du reservation</span>
        <Button close onClick={() => { setopenModal(false) }} style={{ position: 'absolute', right: '10px', top: '10px' }} />
    </ModalHeader>
    <ModalBody>
        <React.Fragment>
            <Row>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Raison sociale</Label>
                        <Input disabled={true} type="text" className="form-control" id="basicpill-firstname-input1" value={RS} />
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom</Label>
                        <Input disabled={true} type="text" className="form-control" id="basicpill-firstname-input1" value={Nom} />
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Prénom</Label>
                        <Input disabled={true} type="text" className="form-control" id="basicpill-firstname-input1" value={Prenom} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Email</Label>
                        <Input disabled={true} type="text" className="form-control" id="basicpill-firstname-input1" value={Email} />
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Type de réservation</Label>
                        <Input disabled={true} type="text" className="form-control" id="basicpill-firstname-input1" value={TypeRes} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Tarif</Label>
                        <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Tarif} />
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Nombre des personnes</Label>
                        <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NbrPers} onChange={(e) => setNbrPers(e.target.value)} />
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-firstname-input1">Durée</Label>
                        <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Duration} onChange={(e) => setDuration(e.target.value)} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg="12">
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="basicpill-address-input1">Message</Label>
                        <textarea id="basicpill-address-input1" className="form-control" rows="5" value={message}></textarea>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    </ModalBody>
</Modal>




          <Modal
                size="xl"
                isOpen={openmodalevaluate}
                toggle={() =>{setopenmodalevaluate(false)}}
                >
                <ModalHeader >
                  Evaluation le membre : {memberSelected?.NomComplet}
                </ModalHeader>
                <ModalBody>
                    <Row>
                      <Col lg="12">
                          <div className="mb-3">
                              <Label className="form-label" htmlFor="basicpill-address-input1">Année d'évaluation</Label>
                              <Input type="text" className="form-control" id="basicpill-phoneno-input3" onChange={(e) =>setevaluatYear(e.target.value)} value={evaluatYear}/>
                          </div>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg="12">
                        <div className="mb-3">
                            <Label className="form-label" htmlFor="basicpill-address-input1">Commentaire</Label>
                            <textarea id="basicpill-address-input1" className="form-control" rows="2" onChange={(e) =>setevaluatCmnt(e.target.value)} value={evaluatCmnt}></textarea>
                        </div>
                    </Col>
                    </Row>
                </ModalBody>
                <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                          >
                              Enregistrer
                          </Button>
                      </div>
          </Modal>

          <Modal
               isOpen={ShowConfirmModal}
               toggle={() => setShowConfirmModal(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModal(false) }>
                Désactiver la page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous désactiver cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModal(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickRemove} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          <Modal
               isOpen={ShowConfirmModalII}
               toggle={() => setShowConfirmModalII(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModalII(false) }>
                Activer la page
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous activer cette page? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModalII(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickEnable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          
        </Container>
        {/* <Modal
            isOpen={modalUpdateIsOpen}
            onRequestClose={closeModal} 
            style={customStyles}
          ></Modal> */}
      </div>
    </React.Fragment>
  );
};

export default Reservation;
